import { ArrowUpRight } from "lucide-react";

export function ServicesSection({ copy, content, language }) {
  return (
    <section className="section services-section" id="services" data-reveal data-testid="services-section">
      <div className="page-width">
        <div className="section-intro section-intro--split"><div><p className="eyebrow">{copy.services.eyebrow}</p><h2>{copy.services.title}</h2></div><p>{copy.services.intro}</p></div>
        <div className="services-grid">
          {content.services.map((service, index) => <article className={`service-card service-card--${index === 0 ? "feature" : "standard"}`} key={service.id} data-testid={`service-card-${service.id}`}>
            <div className="service-image"><img src={service.image_url} alt={language === "en" ? service.title_en : service.title_es} loading="lazy" /><span className="service-index">0{index + 1}</span></div>
            <div className="service-copy"><p className="eyebrow">{index === 0 ? "PRIMARY WORK" : "FIELD SERVICE"}</p><h3>{language === "en" ? service.title_en : service.title_es}</h3><p>{language === "en" ? service.description_en : service.description_es}</p><a href="#quote" data-testid={`service-quote-link-${service.id}`}>{language === "en" ? "Talk through it" : "Hablemos del trabajo"}<ArrowUpRight size={15} /></a></div>
          </article>)}
        </div>
      </div>
    </section>
  );
}
